import { render } from "./CustomerPortal.vue?vue&type=template&id=c81236aa"
import script from "./CustomerPortal.vue?vue&type=script&lang=js"
export * from "./CustomerPortal.vue?vue&type=script&lang=js"

import "@/assets/styles/portal.styl?vue&type=style&index=0&lang=stylus"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__